var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 70C54.3298 70 69.9998 54.3299 69.9998 35C69.9998 15.6701 54.3298 0 34.9998 0C15.6699 0 0 15.6701 0 35C0 54.3299 15.6699 70 34.9998 70Z",
    fill: "#004077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3018 45.4552V22.3569C24.3018 21.0197 25.3959 19.9255 26.7332 19.9255H42.5372C43.8745 19.9255 44.9686 21.0197 44.9686 22.3569V43.0238H26.7332",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7332 43.0239H44.9686C42.5372 44.2396 42.5372 46.671 44.9686 47.8867H26.7332C25.3959 47.8867 24.3018 46.7926 24.3018 45.4553C24.3018 44.1181 25.3959 43.0239 26.7332 43.0239Z",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3208 33.2982L37.6737 29.6511L34.0266 33.2982V19.9255H41.3208V33.2982Z",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/home-icon-2.f634ae830c40a48f01962f86ee219f79.svg";
export { ForwardRef as ReactComponent };